import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-tela-suporte',
  templateUrl: './tela-suporte.component.html',
  styleUrls: ['./tela-suporte.component.scss']
})
export class TelaSuporteComponent implements OnInit {

  public urlDestino = 'https://syncode.movidesk.com/';
  public caminho = 'kb/pt-br/article/37288/index';

  constructor(private route: ActivatedRoute, public domSanitizer: DomSanitizer) { }

  ngOnInit() {
    var caminho;
    this.route.params.subscribe(params => {
      caminho = params['url_destino'];
      if (caminho) {
        caminho = caminho.replace(/147258369/gi, "/");
        this.caminho = caminho;
      }
    });
  }
}


// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-suporte/tela-suporte.component.ts